"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _Grader = _interopRequireDefault(require("./Grader"));

var _Preview = _interopRequireDefault(require("./Preview"));

var _Contact = _interopRequireDefault(require("./Contact"));

var _default = (0, _redux.combineReducers)({
  grader: _Grader.default,
  contact: _Contact.default,
  preview: _Preview.default
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/index.js
// module id = 318
// module chunks = 0